import { render, staticRenderFns } from "./_base-stickyHeader.vue?vue&type=template&id=04102457&scoped=true&"
import script from "./_base-stickyHeader.vue?vue&type=script&lang=js&"
export * from "./_base-stickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./_base-stickyHeader.vue?vue&type=style&index=0&id=04102457&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04102457",
  null
  
)

export default component.exports